export const platformsData = [
  {
    id: 'html5',
    name: 'HTML5 Games',
    shortName: 'Browser',
    description: 'Browser-based gaming experiences',
    longDescription: 'Play instantly in your browser without downloads. Our HTML5 games deliver full gaming experiences accessible from any device with a web browser.',
    color: '#e34c26',
    gamesCount: 5,
  },
  {
    id: 'android',
    name: 'Android',
    shortName: 'Android',
    description: 'Google Play Store releases',
    longDescription: 'Download our games from the Google Play Store. Optimized for Android devices of all sizes, from phones to tablets.',
    color: '#3ddc84',
    gamesCount: 10,
    storeLink: 'https://play.google.com/store',
  },
  {
    id: 'ios',
    name: 'iOS',
    shortName: 'iOS',
    description: 'App Store adventures',
    longDescription: 'Available on the Apple App Store. Experience our games on iPhone and iPad with full iOS optimization.',
    color: '#ffffff',
    gamesCount: 8,
    storeLink: 'https://apps.apple.com',
  },
  {
    id: 'huawei',
    name: 'Huawei AppGallery',
    shortName: 'Huawei',
    description: 'AppGallery releases',
    longDescription: 'Find our games on Huawei AppGallery. Optimized for Huawei and Honor devices.',
    color: '#ff0000',
    gamesCount: 6,
    storeLink: 'https://appgallery.huawei.com',
  },
  {
    id: 'pc',
    name: 'PC Games',
    shortName: 'PC',
    description: 'Steam & Epic releases',
    longDescription: 'Available on Steam and Epic Games Store. Experience our games with full PC features including high-resolution graphics, mod support, and customizable controls.',
    color: '#66c0f4',
    gamesCount: 9,
    storeLink: 'https://store.steampowered.com',
  },
  {
    id: 'xbox',
    name: 'Xbox Series',
    shortName: 'Xbox',
    description: 'Next-gen console gaming',
    longDescription: 'Play on Xbox Series X|S and Xbox One. Featuring full controller support, achievements, and Xbox Game Pass availability for select titles.',
    color: '#107c10',
    gamesCount: 5,
  },
  {
    id: 'playstation',
    name: 'PlayStation',
    shortName: 'PS',
    description: 'PS5 & PS4 titles',
    longDescription: 'Available on PlayStation 5 and PlayStation 4. Experience our games with DualSense features, trophies, and PlayStation Plus benefits.',
    color: '#003791',
    gamesCount: 4,
  },
  {
    id: 'vr',
    name: 'VR/XR/AR',
    shortName: 'VR',
    description: 'Immersive reality experiences',
    longDescription: 'Step into Africa with our virtual, extended, and augmented reality experiences. Supporting Meta Quest, PlayStation VR2, and SteamVR headsets.',
    color: '#9b59b6',
    gamesCount: 2,
  },
];

export const getPlatformById = (id) => platformsData.find(platform => platform.id === id);

export default platformsData;
